import * as React from 'react'
import {connect} from 'react-redux'
import {IStore} from '../../interfaces/reducers'
import {IPopupSettings} from '../../interfaces/models'
import {IPopupDispatcher} from '../../interfaces/dispatchers'
import Draggable from 'react-draggable'
interface OwnProps {
  popupSettings: {[id: string]: IPopupSettings}
  isMobile: boolean
}

interface ParentProps {
  popupDispatcher: IPopupDispatcher
}

interface DispatchProps {}

type Props = ParentProps & OwnProps & DispatchProps
const handleStart = (a: any) => {}
const handleDrag = (a: any) => {}
const handleStop = (a: any) => {}
const FixedPopupRenderer = (props: Props) => {
  const draggableRefs = React.useRef<{[key: string]: React.RefObject<HTMLDivElement>}>({})

  const getDraggableRef = (id: string) => {
    if (!draggableRefs.current[id]) {
      draggableRefs.current[id] = React.createRef<HTMLDivElement>()
    }
    return draggableRefs.current[id]
  }
  const fixedStyle: React.CSSProperties = {
    position: 'fixed',
    top: '0',
    bottom: '0',
    left: '0',
    right: '0',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    zIndex: 100 + Object.keys(props.popupSettings).length,
    display: Object.keys(props.popupSettings).length > 0 ? 'block' : 'none'
  }
  const popups: JSX.Element[] = []
  for (const id in props.popupSettings) {
    popups.push(
      <React.Fragment key={id}>
        <div className="modal-popup-background" style={{zIndex: fixedStyle.zIndex}}></div>
        <div style={{...fixedStyle, display: 'flex'}}>
          <Draggable
            axis={
              props.isMobile || !props.popupSettings[id].draggableAxis ? 'none' : props.popupSettings[id].draggableAxis
            }
            handle=".modal-popup-header"
            defaultPosition={{x: 0, y: 0}}
            position={undefined}
            nodeRef={getDraggableRef(id)}
            onStart={handleStart}
            onDrag={handleDrag}
            onStop={handleStop}
          >
            <div
              ref={getDraggableRef(id)}
              style={{
                width: props.isMobile ? '80%' : props.popupSettings[id].width,
                maxHeight: '80%',
                height: props.popupSettings[id].height
              }}
              className="modal-popup-container"
            >
              <div
                className="modal-popup-header"
                style={{cursor: props.popupSettings[id].draggableAxis ? 'move' : 'default'}}
              >
                {props.popupSettings[id].header}
                {props.popupSettings[id].closeButton ? (
                  <div className="modal-popup-close" onClick={() => props.popupDispatcher.removePopups([id])}>
                    {props.popupSettings[id].closeButton!}
                  </div>
                ) : (
                  <div className="modal-popup-close" onClick={() => props.popupDispatcher.removePopups([id])}>
                    X
                  </div>
                )}
              </div>
              <div className="modal-popup-content">
                <div style={{width: '100%', height: '100%', padding: '10px', boxSizing: 'border-box'}}>
                  {props.popupSettings[id].content}
                </div>
              </div>
            </div>
          </Draggable>
        </div>
      </React.Fragment>
    )
  }
  return <div style={{...fixedStyle}}>{popups}</div>
}

const mapStateToProps = (store: IStore) => ({
  popupSettings: store.popups.popupSettings,
  isMobile: store.application.mobile
})

export default connect<OwnProps, DispatchProps, ParentProps>(mapStateToProps, {})(FixedPopupRenderer)
